import { render, staticRenderFns } from "./NeighborhoodControl.vue?vue&type=template&id=31129dbc&"
import script from "./NeighborhoodControl.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodControl.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports